export const SAVE_BUTTON_LABEL = 'Save'
export const CANCELLED_LABEL = 'Cancelled'
export const NEW_LABEL = 'New'
export const USD_CURRENCY = 'USD'
export const TURKISH_CURRENCY = 'TRY'
export const PREVIEW_MAIN_BUTTON_LABEL = 'Open & Edit'
export const CONTINUE_EDIT_LABEL = 'Continue Edit'
export const NO_LABEL = 'No'
export const YES_LABEL = 'Yes'
export const OK_LABEL = 'Ok'
export const NONE = 'None'
export const CLOSE_LABEL = 'Close'
export const APPROVED_STATUS = 'Approved'
export const FINALIZED_STATUS = 'Finalized'
export const BACK_LABEL = 'Back'
export const NEXT_LABEL = 'Next'
export const FINISH_LABEL = 'Finish'
export const ADD_ITEM = 'Add Item'
export const DEBIT_CREDIT_INVOICE_TYPE = 'DEBIT-CREDIT'
export const REVISED_INVOICE_TYPE = 'Revised Invoice'
export const PROCEED_LABEL = 'Proceed'
export const TRANSFERRED_LABEL = 'Transferred'
export const VOUCHER_ITEMS_CREATED_LABEL = 'Voucher Items Created'
export const DATE_RANGE_LABEL = 'Date Range'
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong...'
export const TIMEOUT_ERROR_CODE = 'ETIMEDOUT'
export const TIMEOUT_ERROR_MESSAGE =
	'The request is taking too long and will be canceled. Please, try again.'
export const CLEAR_FILTERS_TEXT = 'Clear Filters'
export const TOTAL = 'Total'
export const ALL = 'All'
export const UNREAD = 'Unread'

export const EXCEPTIONS_COMMENTS_LABEL = 'Exceptions & Comments'
export const ACTIVITY_LABEL = 'Activity'
export const CUSTOMER_HOME_BTN_TEXT = 'Continue to Dashboard Page'
export const GO_HOME = 'Go Home'

export enum MenuKey {
	HOME = 'Home',
	REPORTS = 'Reports',
	LOGOUT = 'Logout'
}
